
import { Card, FormControlLabel, Checkbox, TextField, Table, TableBody, TableHead, TableRow, TableCell, TableContainer } from "@mui/material"
import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { vendordataSelector, vendordata_updateApprovers } from "reducers/vendordata/vendordata";
import { getUser } from "services/auth";
import Button from "@mui/material/Button";
import classnames from "classnames";
import appdata, { appdataSelector, appdata_setHighlightRequiredFields, appdata_setSnackbar } from "reducers/appdata/appdata";

function Approvers() {
    const vendordata = useSelector(vendordataSelector);
    const appdata = useSelector(appdataSelector);
    const dispatch = useDispatch();
    const stati = { A: "APPROVED", D: "DECLINED", "": "AWAITING" };

    const [verified, setVerified] = useState(false);
    const [comment, setComment] = useState("");
    const [user, setUser] = useState(getUser())
    const [validApprovers, setValidApprovers] = useState({});
    const [userIsAllowedToApproveOrDecline, setUserIsAllowedToApproveOrDecline] = useState(false);
    const [currentApprover, setCurrentApprover] = useState(null);
    const [approving,setApproving] = useState(false);
    const fakeUser = null;

    useEffect(() => {
        console.log("approvers", user, vendordata.approvers);

        // check if current user is in the approvers list

        let currentAppr = null;
        let currentApproverSignum = null;
        if (user && vendordata.approvers) {
            Object.keys(vendordata.approvers).map(key => {
                if (vendordata.approvers[key].SIG_STAT == "" && !currentAppr && (parseInt(vendordata.approvers[key].SIG_EMP) == parseInt(user.employeeId) || parseInt(vendordata.approvers[key].SIG_EMP) == parseInt(fakeUser) ) ) {
                    console.log("set currentapprover to",vendordata.approvers[key]);
                    currentAppr = vendordata.approvers[key];
                    currentApproverSignum = vendordata.approvers[key].SIG_NUM;
                    
                }
            })
        }



        console.log("currentapprover", currentApprover,currentAppr);
        if (currentAppr && currentApprover != currentAppr) {
            setCurrentApprover(currentAppr);
        }



        // if the current user is in the approver list
        // rework the approver list to remove duplicate users with the same SIG_NUM
        let validApprovers = {};
        if (currentAppr) {
            Object.keys(vendordata.approvers).map(key => {
                if (vendordata.approvers[key].SIG_NUM != currentApproverSignum || vendordata.approvers[key] == currentAppr) {
                    validApprovers[Object.keys(validApprovers).length] = vendordata.approvers[key];
                }
            })

        } else {
            console.log("no current approver use all")

            Object.keys(vendordata.approvers).map(key => {
                validApprovers[Object.keys(validApprovers).length] = vendordata.approvers[key];
            })
        }

        console.log("validapprovers", validApprovers);
        setValidApprovers(validApprovers);


        let allowed = false;
        // check if the current user has not approved yet
        if (currentAppr && currentAppr.SIG_STAT == "") {
            allowed = true
        }
        else {
            allowed = false
        }

        // if the user has not approver yet, check if users with the same sig_num have approved
        let otherUserHasAlreadyApproved = false;
        if (currentAppr && vendordata.approvers) {
            Object.keys(vendordata.approvers).map(key => {
                if (currentAppr != vendordata.approvers[key] && currentAppr.SIG_NUM == vendordata.approvers[key].SIG_NUM) {
                    if (vendordata.approvers[key]["SIG_STAT"] != "") {
                        otherUserHasAlreadyApproved = true;
                    }
                }
            })
        }

        if (otherUserHasAlreadyApproved) {
            //setUserIsAllowedToApproveOrDecline(false);
            allowed = false

        }

        // check if previous approver has APPROVED
        if (currentAppr && parseInt(currentAppr.SIG_NUM) > 1) {
            // not the first approver
            allowed=false;
            Object.keys(vendordata.approvers).map((key, i) => {
                if (vendordata.approvers[key].SIG_EMP == currentAppr.SIG_EMP && i > 0) {
                    if (vendordata.approvers[key - 1].SIG_STAT == "A") {
                        allowed = true;
                    }

                }
            })
        }

        if (allowed && !userIsAllowedToApproveOrDecline) {
            setUserIsAllowedToApproveOrDecline(true);
        }
        if (!allowed && userIsAllowedToApproveOrDecline) {
            setUserIsAllowedToApproveOrDecline(false);
        }

    }, [vendordata.approvers])



    const finalApprover = () => {

        if (!vendordata.approvers || !user) {
            return false;
        }

        if (
            parseInt(
                vendordata.approvers[Object.keys(vendordata.approvers).length - 1]["SIG_EMP"]
            ) == parseInt(user.employeeId)
        ) {
            return true;
        } else {
            return false;
        }
    }


    const showCheckbox = () => {

        console.log("showcheckbox", currentApprover)


        if (currentApprover && currentApprover.SIG_TIT == "FIN") {
            if (
                vendordata.approvers[Object.keys(vendordata.approvers).length - 1]["SIG_STAT"] ==
                ""
            ) {
                // check if approver before current approver has approved
                if (
                    Object.keys(vendordata.approvers).length > 1 &&
                    vendordata.approvers[parseInt(currentApprover.SIG_NUM) - 2][
                    "SIG_STAT"
                    ] == "A"
                ) {
                    return true;
                }
                // if there is only one approver, return true
                else if (Object.keys(vendordata.approvers).length == 1) {
                    return true;
                }
            }
            return false;
        }
    }

    const checkVerified = () => {
        if (currentApprover && currentApprover.SIG_TIT == "FIN" && !verified) {
            return false;
        }
        return true;
    }

    const showCommentInput = () => {
        if ( vendordata.activeVendor.master.BACK_2_REQUESTOR != "X" && currentApprover && currentApprover.SIG_STAT == "") {
            return true;
        }
        return false

    }
    const handleChangeVerified = (event) => {
        console.log("handle change verified", event.target.checked);
        if (event.target.checked) {
            setVerified("X");
        } else {
            setVerified(event.target.checked);
        }
    }

    const handleUpdateComment = (event) => {
        /*  if (user) {
             user["ZCOMMENT"] = event.target.value;
         } */
        setComment(event.target.value);
    }

    const handleApproveDecline = (value, sig_num, comment, verified = null) => {

        console.log("handle approve decline", approving);
        console.log("handle approve decline, saved", vendordata.savedToSAP);

        if (approving)
        {
            dispatch(appdata_setSnackbar({ open: true, message: "already in progress" }));
            return;
        }

        setApproving(true);
        
        if (value == "R"){
            console.log("RESET",comment);

            if (!comment){
                console.log('no comment');
                dispatch(appdata_setSnackbar({ open: true, message: "please enter a comment", severity: "error" }))
                setApproving(false);
                return;
            }

            executeApproveDeclineReset(value)
            return;
        }

        let requiredFieldsFilled = true;
        if (Object.keys(vendordata.incompleteRequiredFields).length > 0) {
            console.log("check required fields");
            Object.keys(vendordata.incompleteRequiredFields).map(key => {
                if (typeof vendordata.incompleteRequiredFields[key][0] == "string") {
                    requiredFieldsFilled = false;
                }
                else {
                    Object.keys(vendordata.incompleteRequiredFields[key]).map(id => {
                        if (Object.keys(vendordata.incompleteRequiredFields[key][id]).length > 0) {
                            requiredFieldsFilled = false;

                        }

                    })
                }

            })
        }


        if (!requiredFieldsFilled && value == "A") {
            console.log("approve not allowed yet!")
            dispatch(appdata_setSnackbar({ open: true, message: "please fill out all the required fields", severity: "error" }))
            dispatch(appdata_setHighlightRequiredFields(true));

            setApproving(false);
        }
        else if (!vendordata.savedToSAP && value == "A") {
            console.log("not allowed yet!")
            dispatch(appdata_setSnackbar({ open: true, message: "please save first", severity: "error" }))
            dispatch(appdata_setHighlightRequiredFields(false));

            setApproving(false);
        }
        else {
            let block = false;
            if (block) {
                dispatch(appdata_setSnackbar({ open: true, message: "approving blocked in code" }));
                setApproving(false);
            }
            else {
                console.log("allowed to approve,go")
                setComment("");
                //setApproving(true);
                // allowed
                executeApproveDeclineReset(value)
            }

        }
    }

    const executeApproveDeclineReset = (value) => {
        console.log('execute approve decline reset : ',value);
        
        let approver = {
            REQ_TYP: appdata.activeRequestType,
            SIG_EMP: currentApprover.SIG_EMP,
            SIG_STAT: value,
            SIG_NUM: currentApprover.SIG_NUM,
            ZCOMMENT: comment ? comment : "",
            CALLBACK: verified ? verified : ""
        }

        dispatch(vendordata_updateApprovers(approver))
    }

    const showApproveDecline = (i, approver, docheckverified = false) => {

        if (
            vendordata.activeVendor.master.BACK_2_REQUESTOR != "X" &&
            currentApprover &&
            validApprovers[i] && validApprovers[i].SIG_EMP == currentApprover.SIG_EMP &&
            userIsAllowedToApproveOrDecline &&
            validApprovers[approver].SIG_STAT != "A"
        ) {
            if ((docheckverified && checkVerified()) || !docheckverified) {
                if (i > 0){
                    if (validApprovers[i-1].SIG_STAT != "A"){
                        return false;
                    }
                }
                return true;
            }
        }

        return false;
    }


    console.log("user isallowed", userIsAllowedToApproveOrDecline, validApprovers, currentApprover);

    /* if (Object.keys(validApprovers).length == 0) {
        return;
    } */

    return <Card className="p-4 mt-4">
        <h2 className="article-title">Approvers</h2>
        {/* checkbox */}
        {/* checkbox */}
        {/* checkbox */}
        {/* checkbox */}
        {showCheckbox() && (
            <FormControlLabel
                className="mt-4"
                control={<Checkbox onChange={handleChangeVerified} checked={verified ? true : false} />}
                label="I confirm that I have performed a call back or other method of verification to verify the bank details (if applicable)."
            />
        )}

        {/* comment */}
        {/* comment */}
        {/* comment */}
        {/* comment */}
        {/* comment */}
        {showCommentInput() && (
            <div className="mt-4 col-6 p-0 mb-4">
                Add comment before approving or declining:<br></br>
                <br></br>
                <TextField
                    id="standard-multiline-flexible"
                    label="Comment"
                    multiline
                    rowsmax={4}
                    fullWidth={true}
                    value={comment}
                    onChange={event => {
                        handleUpdateComment(event);
                    }}
                    variant="outlined"
                ></TextField>
            </div>
        )}

        {/* approvers */}
        {/* approvers */}
        {/* approvers */}
        {/* approvers */}
        {/* approvers */}
        <TableContainer
            component={Paper}
        /* className={classnames(classes.tablecontainer, classes.table)} */
        >
            <Table className="mt-4" aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {/* <TableCell>ID</TableCell> */}
                        <TableCell>UserID</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell style={{width:100}}>Status</TableCell>
                        <TableCell style={{width:100}}>Date</TableCell>
                        <TableCell>Comment</TableCell>
                        <TableCell style={{ width: 400, minWidth: 400 }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Object.keys(validApprovers).map((approver, i) => {
                        return (

                            <TableRow
                                key={
                                    validApprovers[i]["SIG_EMP"] +
                                    "_" +
                                    validApprovers[i]["SIG_NUM"]
                                }
                            >
                                {/* <TableCell component="th" scope="row">
                                    {validApprovers[i]["SIG_NUM"] &&
                                        validApprovers[i]["SIG_NUM"]}
                                </TableCell> */}
                                <TableCell component="th" scope="row">
                                    {validApprovers[i]["SIG_EMP"]}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {validApprovers[i]["SIG_NAM"]}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <span
                                        style={{
                                            color:
                                                validApprovers[i]["SIG_STAT"] == "A"
                                                    ? "green"
                                                    : validApprovers[i]["SIG_STAT"] == "D"
                                                        ? "red"
                                                        : "blue"
                                        }}
                                    >
                                        {stati[validApprovers[i]["SIG_STAT"]]}
                                    </span>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {validApprovers[i]["SIG_DAT"]}
                                </TableCell>
                                <TableCell component="th" scope="row">

                                    {/* saved comment */}
                                    {validApprovers[i]["ZCOMMENT"]}

                                    {/* current input comment for current logged in user */}
                                    {currentApprover && validApprovers[i].SIG_EMP == currentApprover.SIG_EMP && comment}

                                </TableCell>

                                <TableCell component="th" scope="row">
                                    <span>
                                        {showApproveDecline(i, approver, true) &&
                                            (
                                                <Button
                                                    className={classnames("besiButton", "d-print-none")}
                                                    variant="contained"
                                                    key={validApprovers[i]["SIG_EMP"] + "submitbutton"}
                                                    color="secondary"
                                                    onClick={() => {
                                                        handleApproveDecline(
                                                            "A",
                                                            currentApprover.SIG_NUM,
                                                            comment,
                                                            verified
                                                        );
                                                    }}
                                                >
                                                    Approve
                                                </Button>
                                            )}
                                        {showApproveDecline(i, approver) &&
                                            (
                                                <Button
                                                    className={classnames(
                                                        "besiButton",
                                                        "d-print-none",
                                                        "declineButton"
                                                    )}
                                                    color="error"
                                                    variant="contained"
                                                    key={validApprovers[i]["SIG_EMP"] + "declinebutton"}
                                                    onClick={() => {

                                                        handleApproveDecline(
                                                            "D",
                                                            currentApprover.SIG_NUM,
                                                            comment
                                                        );
                                                    }}
                                                >
                                                    Decline
                                                </Button>
                                            )}
                                             {showApproveDecline(i, approver) &&
                                            (
                                                <Button
                                                    className={classnames(
                                                        "besiButton",
                                                        "d-print-none",
                                                        "resetButton"
                                                    )}
                                                    color="info"
                                                    variant="contained"
                                                    key={validApprovers[i]["SIG_EMP"] + "resetButton"}
                                                    onClick={() => {

                                                        handleApproveDecline(
                                                            "R",
                                                            currentApprover.SIG_NUM,
                                                            comment
                                                        );
                                                    }}
                                                >
                                                    Reset
                                                </Button>
                                            )}
                                    </span>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>

    </Card>
}

export default Approvers